import { Button, Result, Spin } from "antd";
import NotDataImage from "../../../../old-console-ui/src/assets/images/notData.png";
/** 统一加载态，支持局部区域和全屏阻塞。 */
export function LoadingState({ fullscreen = false, label = "加载中" }: { fullscreen?: boolean; label?: string }) { return <div className={fullscreen ? "common-loading common-loading--fullscreen" : "common-loading"} role="status"><Spin tip={label} /></div>; }
/** 统一空态；数据列表严格复用 Vue 版的 notData 图片和文案结构。 */
export function EmptyState({ type = "data", description }: { type?: "data" | "image" | "video"; description?: string }) {
    const text = description ?? (type === "image" ? "暂无图片" : type === "video" ? "暂无视频" : "暂无数据");
    if (type === "data") {
        return <div className="common-empty common-empty--data"><img src={NotDataImage} alt="notData" width="80" height="51" /><div>{text}</div></div>;
    }
    return <div className={`common-empty common-empty--${type}`}>{text}</div>;
}
/** 统一失败态，存在重试动作时提供明确入口。 */
export function ErrorState({ title = "加载失败", message, onRetry }: { title?: string; message?: string; onRetry?: () => void }) { return <Result status="error" title={title} subTitle={message} extra={onRetry ? <Button type="primary" onClick={onRetry}>重新加载</Button> : undefined} />; }
